"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractRefDefinitions = exports.refImplementation = exports.Ref = void 0;
var METADATA_KEY = '_salvo_refs';
function Ref() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    /* eslint-enable @typescript-eslint/naming-convention, max-len */
    // Default options
    var options = {};
    // Implementation
    function decorator(target, name) {
        return refImplementation(target, name, options);
    }
    // Factory - use as @Observable({..})
    if (args.length < 2) {
        var arg = args[0];
        if (typeof arg == 'string') {
            options = {
                selector: arg
            };
        }
        else {
            options = arg;
        }
        return decorator;
    }
    // Direct - use as @Observable
    var _a = __read(args, 2), target = _a[0], name = _a[1];
    return decorator(target, name);
}
exports.Ref = Ref;
// Implementation
// eslint-disable-next-line @typescript-eslint/ban-types
function refImplementation(target, propertyKey, options) {
    var propertyType = Reflect.getMetadata('design:type', target, propertyKey);
    var propertyTypeName = propertyType.name;
    // TODO
    var defaultSelector = "[data-ref=\"".concat(propertyKey.toString(), "\"]");
    var list = Reflect.getMetadata(METADATA_KEY, target.constructor) || [];
    list.push({
        propertyKey: propertyKey,
        propertyType: propertyType,
        propertyTypeName: propertyTypeName,
        selector: (options === null || options === void 0 ? void 0 : options.selector) || defaultSelector,
        required: (options === null || options === void 0 ? void 0 : options.required) === undefined ? true : options.required,
    });
    Reflect.defineMetadata(METADATA_KEY, list, target.constructor);
}
exports.refImplementation = refImplementation;
/** @internal */
function extractRefDefinitions(targetCtor) {
    return Reflect.getMetadata(METADATA_KEY, targetCtor) || [];
}
exports.extractRefDefinitions = extractRefDefinitions;
//# sourceMappingURL=Ref.js.map